module.exports = __webpack_public_path__ + "media/stop-7.d14fde88.mp3";